import React from "react";
import {Routes} from "../../models/RoutingUrls";

export const Forbidden = (): JSX.Element => {
    return (<div>You do not have access to this page, please <a href={Routes.Login}>Login</a></div>);
};
